import * as Yup from "yup";
import { splitDateStringToParts } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";

export const firmaGennemfoerteTilsynForm = (
  firmaId: string,
  firmaTilsynId?: string,
): FormConfig<FirmaGennemfoerteTilsynDTO> => {
  return {
    title: "gennemført tilsyn",
    lockedValues: [
      {
        id: "firmaId",
        value: firmaId,
      },
      {
        id: "firmaTilsynId",
        value: firmaTilsynId,
      },
    ],
    form: [
      {
        component: "kvartal",
        id: "gennemfoerselDato",
        label: "Gennemført",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "kode-select",
        kodeListeType: "FirmaTilsynstypeKode",
        id: "firmaTilsynstype",
        label: "Type",
        placeholder: "Vælg type",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "sagsNr",
        initialValue: "",
        label: "Sagsnr. F2",
      },
      {
        component: "textarea",
        id: "bemaerkning",
        initialValue: "",
        label: "Bemærkning",
      },
    ],
    validationSchema: Yup.object({
      gennemfoerselDato: Yup.string()
        .required("Kvartal skal være sat")
        .test("gennemfoerselDato", "Årstal skal være sat", (item) => {
          if (item) {
            const parts = splitDateStringToParts(item);
            const [yearPart] = parts;
            return yearPart !== "0000";
          }
          return !!item;
        })
        .test("gennemfoerselDato", "Årstal skal være højere", (item) => {
          if (item) {
            const parts = splitDateStringToParts(item);
            const [yearPart] = parts;
            return yearPart > "1899";
          }
          return false;
        }),
      firmaTilsynstype: Yup.string().required("Tilsynstype skal være sat"),
      sagsNr: Yup.string().max(10, "Sagsnummer må ikke være mere end 10 tegn"),
      bemaerkning: Yup.string(),
    }),
    get: `firma/${firmaId}/tilsyn/${firmaTilsynId}`,
    patch(values: FirmaGennemfoerteTilsynDTO) {
      return {
        query: `firma/${firmaId}/tilsyn/${firmaTilsynId}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    post(values: FirmaGennemfoerteTilsynDTO) {
      return {
        query: `firma/${firmaId}/tilsyn`,
        body: values,
      };
    },
    delete() {
      return {
        query: `firma/${firmaId}/tilsyn/${firmaTilsynId}`,
      };
    },
  };
};
